// extracted by mini-css-extract-plugin
module.exports = {"marketOptions":"MainMarkets_marketOptions__3_YU7","emptyColumn":"MainMarkets_emptyColumn__3WqAF"};